<template>
  <div class="c_table_wrap">
    공지사항 리스트 레이아웃
    <div>
      <button @click="goDetail(idx)">상세</button>
    </div>
    <div>
      <button @click="$router.push('/notice/create')">등록</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "BoardListNoticeLayout",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{
      idx: 1
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
    goDetail(idx) {
      this.$router.push(`/notice/${idx}`);
    },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>